// Data for the Mental Health page resources section.
export const resources = [
    {
      name: 'Student Wellness Centre (SWC) IITB',
      description: 'Confidential counseling and support services available on campus.',
      contact: '022 2576 9070',
    },
    {
      name: 'AASRA Suicide Prevention Helpline',
      description: 'A 24x7 helpline for those in distress.',
      contact: '022 2754 6669',
    },
    {
      name: 'i-Call Psychosocial Helpline',
      description: 'Free telephone and email-based counseling services.',
      contact: '022 2552 1111',
    },
  ];
  